let installed = false

export default {
  install (Vue) {
    if (installed) {
      return
    }
    Vue.prototype.$EventBus = new Vue()
    installed = true
  }
}
